import axios, { AxiosRequestConfig } from 'axios';
import authService from '../auth/auth.service';

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

http.interceptors.request.use(
  (axiosRequestConfig: AxiosRequestConfig): AxiosRequestConfig => {
    const user = authService.getAuth();

    if (user.accessToken) {
      axiosRequestConfig.headers.Authorization = `Bearer ${user.accessToken}`;
    }

    return axiosRequestConfig;
  },
);

export default http;
